import { Routes, Route } from "react-router-dom";
import DomainListPage from "./list";
import DomainViewPage from "./view";

function DomainsPage() {
	return (
		<Routes>
			<Route index element={<DomainListPage />} />
			<Route path="/:id" element={<DomainViewPage />} />
		</Routes>
	);
}

export default DomainsPage;
